import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Scan } from 'src/app/interfaces/scan.interfaces';

@Component({
  standalone: false,
  selector: 'app-sector-header',
  templateUrl: './sector-header.component.html',
})
export class SectorHeaderComponent implements OnInit, OnChanges {
  @Input() x: number = 257;
  @Input() y: number = 18;
  @Input() scan: Scan | undefined;
  @Output() sectorSubmit = new EventEmitter<{ x: number; y: number }>();

  inputX: number = 257;
  inputY: number = 18;
  isChanged = false;

  constructor() { }

  ngOnInit(): void {
    this.inputX = this.x;
    this.inputY = this.y;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isChanged && (changes['x'] || changes['y'])) {
      this.inputX = this.x;
      this.inputY = this.y;
    }
  }

  onSubmit() {
    this.isChanged = false;
    this.sectorSubmit.emit({ x: this.inputX, y: this.inputY });
  }

  onInputChange() {
    this.isChanged = true;
  }
}
